<template>
  <div class="month-profit-container container-with-titleBar">
    <TitleBar
      :show-all-pois="false"
      @poiChangeCallback="poiChangeCallback"
    >
      <div
        class="date-picker"
        @click="showDatePicker"
      >
        {{ year + '年' + month + '月' }}
      </div>
    </TitleBar>
    <section class="profit-overview">
      <div class="top-panel">
        <div class="title">
          <StatusTag
            class="description-icon"
            :status="status"
          >
            {{ month }}月分成
          </StatusTag>
          <span>
            <span>{{ currentIncomeInYuan }}</span>
            <span class="profit">元</span>
          </span>
        </div>
      </div>
      <div
        class="main-panel"
        :class="toggle ? '' : 'panel-short'"
      >
        <ProfitTable v-if="hasCommisionViewAuth">
          <tbody>
            <tr>
              <th>日期</th>
              <th
                class="icon-question"
                @click.stop="showOverviewTip"
              >
                参与分成
              </th>
              <th
                class="icon-question"
                @click.stop="showRateTip"
              >
                比例
              </th>
              <th>我的分成</th>
            </tr>
            <tr
              v-for="dayFlow in settleInDayVOList"
              :key="dayFlow.day"
              @click="gotoDayProfit(dayFlow.day)"
            >
              <td class="poi-name">
                {{ dayFlow.day }}
              </td>
              <td>{{ dayFlow.dayFlowTotalFeeInYuan }}元</td>
              <td>{{ dayFlow.benefitRate }}</td>
              <td>
                {{ dayFlow.currentIncomeInYuan }}元
                <img
                  v-if="!isAgent"
                  class="icon-arrow"
                  src="@/assets/img/arrow-right@2x.png"
                />
              </td>
            </tr>
          </tbody>
        </ProfitTable>
        <ProfitTable
          v-else
          style="width: 100%"
        >
          <tbody>
            <tr>
              <th>日期</th>
              <th>我的分成</th>
            </tr>
            <tr
              v-for="dayFlow in settleInDayVOList"
              :key="dayFlow.day"
            >
              <td class="poi-name">
                {{ dayFlow.day }}
              </td>
              <td>
                {{ dayFlow.currentIncomeInYuan }}元
              </td>
            </tr>
          </tbody>
        </ProfitTable>
      </div>
      <div
        v-if="settleInDayVOList && settleInDayVOList.length >2"
        class="footer-panel"
        @click="handleToggle"
      >
        <img
          class="icon-arrow"
          :class="toggle ? 'opt-up' : 'opt-expand'"
          src="@/assets/img/arrow-right@2x.png"
        />
      </div>
    </section>
    <section
      v-if="hasCommisionViewAuth && monthCost.costType"
      class="profit-overview"
    >
      <div class="cost-panel">
        <div class="title">
          月成本摊销
        </div>
        <div class="content">
          <template>
            <span>{{ monthCost.costType }}</span>
            <span>
              <span>{{ monthCost.costInYuan !== '-' ? `${monthCost.costInYuan}元` : monthCost.costInYuan }}</span>
            </span>
          </template>
        </div>
      </div>
    </section>
    <section
      v-if="hasCommisionViewAuth && (otherRevise && otherRevise.length !== 0)"
      class="profit-overview"
    >
      <div class="cost-panel">
        <div class="title">
          月调整款项
        </div>
        <div
          v-for="item in otherRevise"
          :key="item.reviseType"
          class="content"
        >
          <span>{{ item.reviseType }}</span>
          <span>
            <span>{{ item.reviseInYuan !== '-' ? `${item.reviseInYuan}元` : item.reviseInYuan }}</span>
          </span>
        </div>
      </div>
    </section>
    <van-popup
      v-model="datePickerFlag"
      round
      position="bottom"
    >
      <van-datetime-picker
        v-model="profitDate"
        type="year-month"
        title="选择月份"
        visible-item-count="3"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="handlePickUp"
        @cancel="datePickerFlag = false"
      />
    </van-popup>
    <TipModal
      v-model="isShowOverviewTip"
      title="参与分成"
      msg="参与分成金额=订单金额-订单退款。数据仅供参考，实际数值以已出账单结算为准。"
    />
    <TipModal
      v-model="isShowRateTip"
      title="比例说明"
      msg="显示最新比例，若当月发生过变更，可进入日账单查看详情"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import DatetimePicker from 'vant/lib/datetime-picker';
import TipModal from '@/components/TipModal';

import TitleBar from '@/components/TitleBar';
import StatusTag from '@/components/StatusTag';
import ProfitTable from '@/components/ProfitTable';
import ProfitApi from '@/api/profit';
import STATUS from '@/constants/status';


export default {
  name: 'MonthProfit',
  components: {
    TitleBar,
    StatusTag,
    ProfitTable,
    [DatetimePicker.name]: DatetimePicker,

    TipModal,
  },
  data() {
    return {
      poiId: '',
      profitDate: new Date(2021, 7),
      minDate: new Date(2020, 0),
      maxDate: new Date(2021, 7),
      datePickerFlag: false,
      loading: false,
      isShowOverviewTip: false,
      isShowRateTip: false,
      toggle: false,
      currentIncomeInYuan: '',
      settleInDayVOList: [],
      monthCost: {},
      otherRevise: [],
      status: 1,
    };
  },
  computed: {
    ...mapState(['currentPoi', 'isAgent', 'hasCommisionViewAuth', 'bizlogintoken', 'profitMonth']),
    year() {
      return this.profitDate.getFullYear();
    },
    month() {
      return this.profitDate.getMonth() + 1;
    },
  },
  mounted() {
    if (this.profitMonth) {
      const year = this.profitMonth.split('-') && +this.profitMonth.split('-')[0];
      const month = this.profitMonth.split('-') && +this.profitMonth.split('-')[1];
      this.profitDate = new Date(year, month - 1);
    }
    this.getData();
  },
  methods: {
    ...mapMutations(['setProfitMonth']),
    formatter(type, value) {
      if (type === 'year') {
        return `${value}年`;
      } else if (type === 'month') {
        return `${value}月`;
      } else {
        return value;
      }
    },
    async getData() {
      const { poiId } = this.currentPoi;
      this.poiId = poiId;
      this.$store.commit('setLoading', true);
      const res = await ProfitApi.getSummaryDayList(poiId, this.year, this.month);
      const monthCostRes = await ProfitApi.getSummaryMonthCost(poiId, this.year, this.month);
      const otherReviseRes = await ProfitApi.getSummaryMonthOtherRevise(poiId, this.year, this.month);
      if (res.respCode === STATUS.SUCCESS) {
        const {
          currentIncomeInYuan, status, settleInDayVOList,
        } = res.data || {};

        this.currentIncomeInYuan = currentIncomeInYuan;
        this.status = status;
        this.settleInDayVOList = settleInDayVOList;
      }
      if (monthCostRes.respCode === STATUS.SUCCESS) {
        this.monthCost = monthCostRes.data || {};
      }
      if (otherReviseRes.respCode === STATUS.SUCCESS) {
        this.otherRevise = otherReviseRes.data || [];
      }
      this.$store.commit('setLoading', false);
    },
    showDatePicker() {
      this.datePickerFlag = true;
    },
    handleToggle() {
      this.toggle = !this.toggle;
    },
    handlePickUp() {
      this.datePickerFlag = false;
      this.setProfitMonth(`${this.year}-${this.month}`);
      this.getData();
    },
    poiChangeCallback() {
      this.getData();
    },
    showOverviewTip() {
      this.isShowOverviewTip = true;
    },
    showRateTip() {
      this.isShowRateTip = true;
    },
    gotoDayProfit(day) {
      if (this.isAgent) {
        return;
      }
      this.$router.push(`/dayProfit?day=${day}`);
    },
  },
};
</script>
<style  lang="scss" scoped>
.month-profit-container {
  padding: 0 0 170px;
  .date-picker {
    position: relative;
    padding-right: 30px;
    color: rgba(0, 0, 0, .84);
    font-size: 26px;
    &::after {
      content: '';
      position: absolute;
      display: block;
      top: 50%;
      right: 0;
      width: 24px;
      height: 24px;
      margin-top: -12px;
      background: url(~@/assets/img/drop-down.png) no-repeat center center;
      background-size: 24px;
    }
  }
  .profit-overview {
    background: #fff;
    margin: 18px;
    padding: 30px 0 36px 36px;
    border-radius: 12px;
    .top-panel {
      border-bottom: 1px solid rgba(0,0,0,0.12);;
      padding-bottom: 30px;
      padding-right: 36px;
      text-align: left;
      .title {
        display: flex;
        justify-content: space-between;
        font-size: 32px;
        font-weight: bold;
        color: rgba(0,0,0,0.84);
        line-height: 45px;
        .profit {
          margin-left: 6px;
          font-size: 24px;
        }
      }
      .desc {
        display: flex;
        justify-content: space-between;
        margin-top: 6px;
        font-size: 28px;
        color: rgba(0,0,0,0.42);
        line-height: 40px;
        .warn-tip {
          color: #C28100;
        }
      }
    }
    .cost-panel {
      .title {
        text-align: left;
        font-size: 32px;
        font-weight: bold;
        color: rgba(0,0,0,0.84);
        line-height: 45px;
        padding-bottom: 30px;
        padding-right: 36px;
        border-bottom: 1px solid rgba(0,0,0,0.12);
      }
      .content {
        display: flex;
        justify-content: space-between;
        padding-top: 30px;
        padding-right: 36px;
      }
    }
    .panel-short{
      overflow: hidden;
      max-height: 260px;
    }
    .main-panel {
      margin-top: 24px;
      padding-right: 36px;
      text-align: left;
      justify-content: space-between;
      display: flex;

      .left-panel {
        display: inline-block;
      }
      .right-panel {
        display: inline-block;
        margin-right: 36px;
      }
      .profit {
        position: relative;
        padding-right: 36px;
        text-align: left;
        font-size: 72px;
        font-weight: bold;
        &::after {
          content: '元';
          position: absolute;
          right: 0;
          bottom: 16px;
          font-size: 30px;
        }
      }
      .icon-question  {
        &::after {
          display: inline-block;
          content: '';
          vertical-align: middle;
          margin-top: -4px;
          width: 24px;
          height: 24px;
          background: url(~@/assets/img/icon-question.png) no-repeat center center;
          background-size: 24px;
        }
      }
    }
    .footer-panel {
      text-align: center;
      .icon-arrow{
        vertical-align: middle;
        display: inline-block;
        margin-top: 10px;
        width: 40px;
        height: 40px;
      }
      .opt-expand {
        transform:rotate(90deg);
      }
      .opt-up {
        transform:rotate(270deg);
      }
    }
  }
  .profit-prompt {
    text-align: center;
  }
}
</style>
